export default "__VITE_ASSET__DSXPqj6B__"